"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promisify = promisify;
exports.listToMatrix = listToMatrix;
exports.IDGenerator = IDGenerator;
exports.trimStringsInObjects = trimStringsInObjects;
exports.errorHandler = errorHandler;
exports.handleErrorNotification = handleErrorNotification;
exports.showError = showError;
exports.readFileAsync = readFileAsync;
exports.resposiveSpan = resposiveSpan;
exports.moreResposiveSpan = moreResposiveSpan;
exports.confirmAction = confirmAction;
exports.tableRender = tableRender;
exports.rowRender = rowRender;
exports.compareArrays = compareArrays;
exports.getAppName = getAppName;
exports.customClaimsCheck = customClaimsCheck;
exports.defaultGetValueFromEvent = defaultGetValueFromEvent;
exports.masterUrl = masterUrl;
exports.generateEmailLink = generateEmailLink;
exports.numberValidator = numberValidator;
exports.incrementCounter = exports.toggleKey = exports.makeUpdater = exports.toasterOptions = exports.exportToExcelFunction = exports.promptMsgExceptForHistoryBack = exports.confirm = exports.createDispatchService = exports.ObjectbyString = exports.convertRoutesToMenu = exports.dateFormat = exports.dbDateFormat = void 0;

var _lodash = require("lodash");

var _reactToastify = require("react-toastify");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dbDateFormat = "YYYY-MM-DD";
exports.dbDateFormat = dbDateFormat;
var dateFormat = "DD-MMM-YYYY";
exports.dateFormat = dateFormat;

var convertRoutesToMenu = function convertRoutesToMenu(routes, url) {
  return routes.map(function (r) {
    return _objectSpread(_objectSpread({}, r.props), {}, {
      path: url + r.props.path,
      menus: r.props.menus ? r.props.menus.map(function (menu) {
        return _objectSpread(_objectSpread({}, menu), {}, {
          path: url + menu.path
        });
      }) : null
    });
  });
};

exports.convertRoutesToMenu = convertRoutesToMenu;

var ObjectbyString = function ObjectbyString(o, s) {
  s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties

  s = s.replace(/^\./, ""); // strip a leading dot

  var a = s.split(".");

  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];

    if (o && k in o) {
      o = o[k];
    } else {
      return;
    }
  }

  return o;
};

exports.ObjectbyString = ObjectbyString;

function promisify(f) {
  var manyArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new Promise(function (resolve, reject) {
      function callback(err) {
        // our custom callback for f
        if (err) {
          reject(err);
        } else {
          for (var _len2 = arguments.length, results = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            results[_key2 - 1] = arguments[_key2];
          }

          // resolve with all callback results if manyArgs is specified
          resolve(manyArgs ? results : results[0]);
        }
      }

      args.push(callback);
      f.call.apply(f, [_this].concat(args));
    });
  };
}

var createDispatchService = function createDispatchService(commonService) {
  return function (dispatch, service) {
    return promisify(function () {
      for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        params[_key3] = arguments[_key3];
      }

      var cb = params.pop();
      var args = params[0];
      dispatch(commonService({
        service: service,
        args: args
      }, cb));
    });
  };
};

exports.createDispatchService = createDispatchService;

function listToMatrix(list, elementsPerSubArray) {
  var matrix = [],
      i,
      k;

  for (i = 0, k = -1; i < list.length; i++) {
    if (i % elementsPerSubArray === 0) {
      k++;
      matrix[k] = [];
    }

    matrix[k].push(list[i]);
  }

  return matrix;
}

function IDGenerator() {
  this.length = 8;
  this.timestamp = +new Date();

  var _getRandomInt = function _getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  this.generate = function () {
    var ts = this.timestamp.toString();
    var parts = ts.split("").reverse();
    var id = "";

    for (var i = 0; i < this.length; ++i) {
      var index = _getRandomInt(0, parts.length - 1);

      id += parts[index];
    }

    return id;
  };
}

function trimStringsInObjects(obj) {
  Object.keys(obj).forEach(function (key) {
    if (typeof obj[key] === "string") {
      obj[key] = obj[key].trim();
    }

    if (obj[key] && _typeof(obj[key]) === "object") {
      obj[key] = trimStringsInObjects(obj[key]);
    }
  });
  return obj;
}

function errorHandler(err) {
  if (Array.isArray(err) && err.length) {
    errorHandler({
      graphQLErrors: err
    });
  }

  var graphQLErrors = err.graphQLErrors,
      networkError = err.networkError;
  var message = "Something unexpected happened, please try again";

  if (graphQLErrors && graphQLErrors.length) {
    message = graphQLErrors.map(function (_ref) {
      var errorCode = _ref.errorCode,
          message = _ref.message,
          _ref$exception = _ref.exception,
          exception = _ref$exception === void 0 ? {} : _ref$exception,
          locations = _ref.locations,
          path = _ref.path;
      console.error("Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path));
      return exception.message || message || errorCode || "";
    }).join(",");
  } else if (networkError) {
    message = "Network error - ";
    message += networkError.message;
    console.error(message, graphQLErrors);
  } else {
    throw err;
  }

  throw new Error(message);
}

function handleErrorNotification(err) {
  var graphQLErrors = err.graphQLErrors,
      networkError = err.networkError;
  console.log("handleErrorNotification", err, graphQLErrors, networkError);
  var msg = "Something unexpected happend, please try again";
  Promise.resolve().then(function () {
    return _interopRequireWildcard(require("cornerstone_ui_core/lib/components/CornerstoneMessage"));
  }).then(function (message) {
    if (graphQLErrors && graphQLErrors.length > 0) {
      if (!graphQLErrors[0].message && graphQLErrors[0].errorCode) {
        /* If message is null, but error code is present, display error code. */
        message.default.error(graphQLErrors[0].errorCode);
        return null;
      } else if (graphQLErrors[0].message) {
        /* If message is present, display message. */
        var _err = graphQLErrors[0].message && graphQLErrors[0].message !== "" && graphQLErrors[0].message.includes(":") && graphQLErrors[0].message.split(":")[1] !== "null" && graphQLErrors[0].message.split(":")[1] !== " null" ? graphQLErrors[0].message.split(":")[1] : graphQLErrors[0].exception && graphQLErrors[0].exception.errorCode ? graphQLErrors[0].exception.errorCode : graphQLErrors[0].message;

        message.default.error(_err, JSON.parse(localStorage.getItem("toasterOptions")));
        return null;
      } else {
        message.default.error("Error in backend service.", JSON.parse(localStorage.getItem("toasterOptions")));
        return null;
      }
    } else if (networkError) {
      console.error("[Network error]: ".concat(networkError));
      msg = networkError;
    } else {
      message.default.error("Request time out error.", JSON.parse(localStorage.getItem("toasterOptions")));
    }

    throw new Error(msg);
  });
}

function showError(errors) {
  console.log("showError", errors);
  Promise.resolve().then(function () {
    return _interopRequireWildcard(require("cornerstone_ui_core/lib/components/CornerstoneMessage"));
  }).then(function (message) {
    if (errors && errors.length > 0 && errors[0]) {
      if (errors[0].message) {
        message.default.error(errors[0].message, JSON.parse(localStorage.getItem("toasterOptions")));
      } else if (errors[0].name) {
        message.default.error(errors[0].name, JSON.parse(localStorage.getItem("toasterOptions")));
      } else {
        message.default.error("Error in service.", JSON.parse(localStorage.getItem("toasterOptions")));
      }
    }
  });
}

function readFileAsync(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    reader.onload = function () {
      resolve(reader.result);
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function resposiveSpan() {
  var span = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 24;
  return {
    span: span,
    xs: 24,
    sm: span * 3,
    md: span * 2,
    lg: span * 2,
    xl: span * 1,
    xxl: span * 1
  };
}

function moreResposiveSpan() {
  var span = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 24;
  return {
    span: span,
    xs: 24,
    sm: span * 5,
    md: span * 4,
    lg: span * 3,
    xl: span * 2,
    xxl: span * 1
  };
}

function confirmAction(action, message) {
  var forceGoBack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (forceGoBack) {
    return action();
  }

  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("cornerstone_ui_core/lib/components/Modal"));
  }).then(function (Modal) {
    return Modal.default.confirm({
      title: "Confirm",
      content: message,
      onOk: function onOk() {
        return action();
      }
    });
  });
}

var confirm = function confirm(_ref2) {
  var title = _ref2.title,
      content = _ref2.content;
  return new Promise(function (resolve, reject) {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require("cornerstone_ui_core/lib/components/Modal"));
    }).then(function (Modal) {
      return Modal.default.confirm({
        title: title,
        content: content,
        onOk: function onOk() {
          return resolve();
        },
        onCancel: function onCancel() {
          return reject();
        }
      });
    });
  }).then(function () {
    return true;
  }).catch(function () {
    return false;
  });
};

exports.confirm = confirm;

var promptMsgExceptForHistoryBack = function promptMsgExceptForHistoryBack() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "You have unsaved changes, are you sure you want to leave?";
  return function (location, action) {
    if (action === "POP") return true;
    if (action === "REPLACE") return true;
    return message;
  };
};

exports.promptMsgExceptForHistoryBack = promptMsgExceptForHistoryBack;

function tableRender(columns, dataSource) {
  return dataSource.map(function (data, i) {
    return columns.map(function (col) {
      var value = (0, _lodash.get)(data, col.dataIndex || col.key);
      return col.render ? col.render(value, data, i) : value;
    });
  });
}

function rowRender(columns, data) {
  var row = tableRender(columns, [data])[0];
  return columns.map(function (col, i) {
    return {
      col: col,
      output: row[i]
    };
  });
} //============================================================================


var exportToExcelFunction = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var exportToExcelFunction,
        _len4,
        args,
        _key4,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.resolve().then(function () {
              return _interopRequireWildcard(require("./exportToExcel"));
            });

          case 2:
            exportToExcelFunction = _context.sent;

            for (_len4 = _args.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              args[_key4] = _args[_key4];
            }

            return _context.abrupt("return", exportToExcelFunction.default.apply(null, args));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function exportToExcelFunction() {
    return _ref3.apply(this, arguments);
  };
}(); //==================================


exports.exportToExcelFunction = exportToExcelFunction;
var toasterOptions = {
  position: _reactToastify.toast.POSITION.TOP_LEFT,
  autoClose: false
};
exports.toasterOptions = toasterOptions;

function compareArrays() {
  var newData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var oldData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var iteratee = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (obj) {
    return obj.key;
  };
  var comparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _lodash.isEqual;
  var created = (0, _lodash.differenceBy)(newData, oldData, iteratee);
  var deleted = (0, _lodash.differenceBy)(oldData, newData, iteratee);
  var rest = (0, _lodash.differenceBy)(newData, created, iteratee);
  var changed = (0, _lodash.differenceWith)(rest, oldData, comparator);
  var unchanged = (0, _lodash.differenceBy)(rest, changed, iteratee);
  return [created, deleted, changed, unchanged, rest];
}

var makeUpdater = function makeUpdater(apply) {
  return function (key) {
    return function (state) {
      return _defineProperty({}, key, apply(state[key]));
    };
  };
};

exports.makeUpdater = makeUpdater;
var toggleKey = makeUpdater(function (previous) {
  return !previous;
});
exports.toggleKey = toggleKey;
var incrementCounter = makeUpdater(function (previous) {
  return previous + 1;
});
exports.incrementCounter = incrementCounter;

function getAppName() {
  var AppId = localStorage.getItem("AppId");
  if (AppId) return AppId;else if (window.location && window.location.hostname && window.location.hostname.substring(0, 3)) return window.location.hostname.substring(0, 3).toUpperCase();else return null;
}

function customClaimsCheck(customClaims, customClaimKeyToCheck) {
  var isCustomClaimAvailable = false;
  customClaims.map(function (claim) {
    if (claim.k === customClaimKeyToCheck) isCustomClaimAvailable = true;
  });
  return isCustomClaimAvailable;
}

function defaultGetValueFromEvent(e) {
  if (!e || !e.target) {
    return e;
  }

  var target = e.target;
  return target.type === "checkbox" ? target.checked : target.value;
}

function masterUrl() {
  var hostname = window.location.hostname.replace(/^[^.]+\./g, "");
  var port = window.location.port === "" ? "" : ":".concat(window.location.port);
  return "".concat(window.location.protocol, "//").concat(hostname).concat(port);
}

function generateEmailLink(appComponentURL) {
  return "".concat(masterUrl(), "/accessURL?q=").concat(appComponentURL);
}

function numberValidator(min, max) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "value";
  return function (rule, value, callback) {
    if (value && isNaN(value)) {
      return callback("".concat(name, " must be a number"));
    }

    if (!isNaN(min) && value < min) {
      return callback("".concat(name, " must be greater than or equal to ").concat(min));
    } else if (!isNaN(max) && value > max) {
      return callback("".concat(name, " must be less than or equal to ").concat(max));
    } else {
      return callback();
    }
  };
}